module.exports = __webpack_public_path__ + "img/PerdidaDeVideo.ac6112d7.svg";